/**
 * Loading state for the storefront's commerce CTAs (BUG138).
 *
 * Puts any `.forcast-cta` into `data-loading="true"` from the moment it is
 * clicked; assets/forcast-cta.css turns that into the ring that replaces the
 * label. The PDP "Add to bag" button is where this behaviour started — it is
 * the button the rest were asked to match.
 *
 * Delegated from `document` rather than bound per element on purpose: the cart
 * drawer's Checkout button is inside a subtree that cart-items-component morphs
 * on every cart change, and the PDP buy buttons are re-rendered by the section
 * renderer when a variant changes. A bound listener would be dropped by both.
 */
(() => {
  const SELECTOR = '.forcast-cta';
  /* Never leave a ring spinning forever if no cart event ever arrives. */
  const SAFETY_MS = 8000;

  let safety = null;

  const stop = () => {
    for (const cta of document.querySelectorAll(`${SELECTOR}[data-loading='true']`)) {
      cta.removeAttribute('data-loading');
    }
    if (safety) {
      clearTimeout(safety);
      safety = null;
    }
  };

  document.addEventListener('click', (event) => {
    const cta = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
    if (!cta) return;

    /* Mirror the guards in AddToCartComponent#handleClick: a disabled button or
       an invalid form never fires a request, so it must not spin. */
    if (cta.disabled || cta.getAttribute('aria-disabled') === 'true') return;
    const form = cta.closest('form');
    if (form && !form.checkValidity()) return;

    cta.dataset.loading = 'true';
    if (safety) clearTimeout(safety);
    safety = setTimeout(stop, SAFETY_MS);
  });

  /* cart:update is the shared name for CartAddEvent and CartUpdateEvent, so
     this covers a successful add; cart:error covers a rejected one. The Athos
     quick-add sheet reports its own failure instead (snap/src/components/
     QuickAddDrawer.js) — without it the "Try again" label it swaps in would sit
     behind the ring until the safety timeout. */
  document.addEventListener('cart:update', stop);
  document.addEventListener('cart:error', stop);
  document.addEventListener('forcast:quick-add-failed', stop);

  /* The Checkout link and the "Style it with" form navigate away rather than
     answering on the page, so their ring is cleared by the unload — except on a
     back/forward restore, where the old DOM comes back exactly as it left. */
  window.addEventListener('pageshow', stop);
})();
